<template>
  <div class="under-contribute">
    <img :src="underContributeImage" alt="" />
  </div>
</template>

<script>
import underContributeImage from "@/assets/images/under-contribute.png";

export default {
  name: "UnderContribute",
  data() {
    return {
      underContributeImage
    };
  }
};
</script>

<style scoped lang="scss">
.under-contribute {
  height: calc(100vh - 140px);
  overflow: hidden;
  background-color: rgba(241, 241, 241, 1);
  img {
    display: block;
    margin: 0 auto;
    padding-top: 90px;
  }
}
</style>
